// CSS
import './AnimatedLogoOverlay.css';
// Media assets
import AnimatedHorizontalLogo from '../../assets/videos/skybase-framer-logo.webm';


// AnimatedLogoOverlay
// ===================
// Displays a <video/> of the animated Skybase Logo.
function AnimatedLogoOverlay(){
    
    // JSX Component
    return(
        <div className='AnimatedLogoOverlay'>
            <video
                className='AnimatedLogoOverlay-video'
                autoPlay
                loop
                muted
                playsInline>
                <source src={AnimatedHorizontalLogo} type="video/webm"/>
            </video>
        </div>
    ); 
};


// Export statement
export default AnimatedLogoOverlay;